export default __webpack_public_path__ + "static/Asset 41-4d4108e4f3b5070ccde42484638852b5.png";